import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClipboardService } from 'ngx-clipboard';
import { NotificationService } from '../../notification-service/notification.service';

@Component({
  selector: 'app-thread-details-dialog',
  templateUrl: './thread-details-dialog.component.html',
  styleUrls: ['./thread-details-dialog.component.scss'],
  standalone: false,
})
export class ThreadDetailsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ThreadDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clipboardService: ClipboardService,
    private notify: NotificationService
  ) {}

  copyToClipboard(): void {
    this.clipboardService.copyFromContent(JSON.stringify(this.data, null, 2));
    this.notify.success('Thread details copied to clipboard');
  }

  close(): void {
    this.dialogRef.close();
  }
}
